import scroll from "./scroll";

const modal = {
    open: false,

    init() {
        $(document).on("click", "._open_mentions", function () {
            $(".__mentions").addClass("_show");
            scroll.locomotiveScroll.stop();
            // setTimeout(function () {
            //     $(".__mentions > ._contain").css("overflow-y", "auto");
            // }, 1500);
            //console.log(scroll.locomotiveScroll);
        });

        $(document).on("click", "._open_confidentialite", function () {
            $(".__confidentialite").addClass("_show");
            scroll.locomotiveScroll.stop();
        });

        $(document).on("click", ".__close_modal", function () {
            $(".__modal").removeClass("_show");
            scroll.locomotiveScroll.start();
        });

        $(document).on("click", ".__list_select", function () {
            $(this).toggleClass("_open");
        });

        $(document).on("click", "._options > span", function () {
            let _id = $(this).data("id");
            let _txt = $(this).html();
            $(".__choice_value > span").html(_txt);
            $("input[name=recall_type]").val(_id);
        });

        // Ajout de la mise en forme automatique des numéros de téléphone
        $(document).on("input", "input[type=phone]", function (e) {
            let value = e.target.value.replace(/\D/g, ''); // Supprimer tout sauf les chiffres
            let formattedValue = '';

            // Formatage des groupes de deux chiffres
            for (let i = 0; i < value.length; i += 2) {
                if (i > 0 && i < 10) { // Ajoute un espace après chaque deux chiffres sauf après le dernier groupe
                    formattedValue += ' ';
                }
                formattedValue += value.substring(i, i + 2);
            }

            e.target.value = formattedValue.substring(0, 14); // Limiter à 14 caractères
        });
    }
};

export default modal;
